import { Box } from '@material-ui/core';
import { SSearchInput } from '../../../../sforms';
import { useUserSnippets } from './useUserSnippets';
import SInfiniteScroll from '../../../../sinfinite-scroll';
import { DrawerLoader } from '../../../components/loader';
import { SnippetCard } from '../../../components/snippet/card';
import { Snippet } from '../../../../../services/react-query/query/snippets/types';
import { SEmptyState } from '../../../..';

interface UserSnippetsProps {
  onSnippetClick: (snippet: Snippet) => void;
}

export const UserSnippets = ({ onSnippetClick }: UserSnippetsProps) => {
  const { search, setSearch, snippets, isLoading } = useUserSnippets();

  return (
    <>
      <Box m={2}>
        <SSearchInput defaultValue={search} onChange={setSearch} />
      </Box>
      <Box overflow="auto">
        <SInfiniteScroll
          list={snippets}
          keyGetter={el => el.Id}
          render={snippet => (
            <SnippetCard
              snippet={snippet}
              name={snippet.Name}
              lastModified={snippet.LastChanged}
              onSnippetClick={onSnippetClick}
            />
          )}
        />
        {isLoading && <DrawerLoader showImage={false} />}
        {!isLoading && snippets?.length === 0 && (
          <Box>
            <SEmptyState
              imageSrc="/images/no-my-snippets.png"
              title="No Snippets Available"
            />
          </Box>
        )}
      </Box>
    </>
  );
};
